/**
 * HWCG per-field Task edit: one pencil field at a time, and section overrides
 * merged into the tip payload before an append-only PUT.
 */

export type TaskPencilFieldKey =
  | 'name'
  | 'description'
  | 'start_date'
  | 'target_date';

/** Starting another pencil field cancels the previous (return the requested key). */
export function nextEditingFieldKey(
  _current: TaskPencilFieldKey | null,
  requested: TaskPencilFieldKey | null
): TaskPencilFieldKey | null {
  return requested;
}

export function isPencilFieldEditing(
  editingKey: TaskPencilFieldKey | null,
  fieldKey: TaskPencilFieldKey
): boolean {
  return editingKey === fieldKey;
}

export type TaskPersistOverrides = Record<string, unknown>;

/** Merge section/local overrides over the form-derived tip payload. */
export function mergePersistOverrides<T extends Record<string, unknown>>(
  base: T,
  overrides?: TaskPersistOverrides | null
): T {
  if (!overrides || Object.keys(overrides).length === 0) return base;
  return { ...base, ...overrides };
}

/** Pull a tip row id out of an axios PUT response or bare row. */
export function tipIdFromUpdateResult(result: unknown): string | null {
  if (!result || typeof result !== 'object') return null;
  const data = (result as { data?: unknown }).data ?? result;
  if (!data || typeof data !== 'object') return null;
  const id = (data as { id?: unknown }).id;
  return typeof id === 'string' && id.length > 0 ? id : null;
}

export function tipRowFromUpdateResult(
  result: unknown
): Record<string, unknown> | null {
  if (!result || typeof result !== 'object') return null;
  const data = (result as { data?: unknown }).data ?? result;
  if (!data || typeof data !== 'object') return null;
  const row = data as Record<string, unknown>;
  return typeof row.id === 'string' ? row : null;
}
